import { render, staticRenderFns } from "./popup-new-shipping-address.vue?vue&type=template&id=546c7326&"
import script from "./popup-new-shipping-address.vue?vue&type=script&lang=js&"
export * from "./popup-new-shipping-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports